<div class="enact-colorpicker">
  <span class="color-picker-label">
    <ng-content></ng-content>
  </span>
  <div class="input-wrapper">
    <input
      matInput
      (click)="onColorPopUp($event)"
      [value]="selectedColor.name"
      readonly
    />
    <div
      class="colorBox"
      [ngStyle]="{ 'background-color': selectedColor.value }"
    ></div>
    <div class="dropdown-arrow" (click)="onColorPopUp($event)">
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" stroke="#00BCD4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
  <div class="overlay" *ngIf="enabledPopUp">
    <div class="popup">
      <label class="lableClass" *ngIf="presetLabelName">{{
        presetLabelName
      }}</label>
      <div class="flex-box">
        <div
          class="colorselection"
          *ngFor="let color of enactPresetColors"
          [ngStyle]="{ 'background-color': color.value }"
          (click)="onChangeColor(color)"
        >
          <div
            [ngClass]="
              selectedColor.name == color.name ? 'checked' : 'unchecked'
            "
          >
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
